import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.5 5a1.5 1.5 0 1 0 2.915-.5M9.5 5a1.5 1.5 0 0 1 2.915-.5M9.5 5c-2.833.667-7 5.5-5.176 11.66m0 0a1.5 1.5 0 1 0 1.352 2.679 1.5 1.5 0 0 0-1.352-2.678Zm8.09-12.16c4.086 0 3.35 5.5 6.468 6.5m0 0a1.5 1.5 0 1 0 2.236 2 1.5 1.5 0 0 0-2.236-2Z",
  stroke: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }